/*******************************************************************************
 * Copyright     : Copyright (c)  2024 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc.No part may be reproduced or transmitted in any form by any
 *                 means or for anypurpose without the express written permission of Honeywell. *
 *******************************************************************************/
import { createAction } from "@reduxjs/toolkit";

import { ViewTypeProps } from "../models";

export const setOrgList = createAction<ViewTypeProps>('SET_ORG_LIST');
export const setRBMDetails = createAction<ViewTypeProps>('SET_RBM_DETAILS');
export const setSiOrgLists = createAction<ViewTypeProps>('SET_SI_ORG_LISTS');
export const setCustomerType = createAction<ViewTypeProps>('SET_CUSTOMER_TYPE');
export const setOrganizations = createAction<ViewTypeProps>('SET_ORGANIZATIONS');
export const setHeaderDetails = createAction<ViewTypeProps>('SET_HEADER_DETAILS');
export const setLogoutIntiated = createAction<ViewTypeProps>('SET_LOGOUT_INTIATED');
export const setRBMAccessToken = createAction<ViewTypeProps>('SET_RBM_ACCESS_TOKEN');
export const setDeviceListUpdated = createAction<ViewTypeProps>('SET_DEVICE_LIST_UPDATED');
export const setFilterItems = createAction<ViewTypeProps>('SET_FILTER_ITEMS');
export const setDeviceListPagination = createAction<ViewTypeProps>('SET_DEVICE_LIST_PAGINATION');
export const setViewTypeFilterItems = createAction<ViewTypeProps>('SET_VIEW_TYPE_FILTER_ITEMS');

// Software-specific actions
export const setSoftwareDetails = createAction<ViewTypeProps>('SET_SOFTWARE_DETAILS');
export const clearSoftwareDetails = createAction('CLEAR_SOFTWARE_DETAILS');
export const setSoftwareNotification = createAction<ViewTypeProps>('SET_SOFTWARE_NOTIFICATION');
export const setSoftwareVersions = createAction<ViewTypeProps>('SET_SOFTWARE_VERSIONS');
export const setTargetForgePoints = createAction<ViewTypeProps>('SET_TARGET_FORGE_POINTS');
export const setSoftwareLogs = createAction<ViewTypeProps>('SET_SOFTWARE_LOGS');
export const setAppConfig = createAction<ViewTypeProps>('SET_APP_CONFIG');